import React from 'react'
import PropTypes from 'prop-types'
import PROPTYPES from '../../../lib/propTypes'
import Select from 'react-select'
import _ from 'lodash'
import constants from '../../../lib/constants'

class SalesAssignment extends React.Component {
  static propTypes = {
    prescribers: PROPTYPES.prescribers,
    users: PROPTYPES.users,
    isFetchingUsers: PropTypes.bool,
    isFetchingPrescribers: PropTypes.bool,
    updateSalesPerson: PropTypes.func,
    getUsers: PropTypes.func
  }

  static defaultProps = {
    prescribers: [],
    users: [],
    isFetchingUsers: false,
    isFetchingPrescribers: false,
    updateSalesPerson: _.noop,
    getUsers: _.noop
  }

  constructor (ownProps) {
    super(ownProps)
    this.state = {
      selectedPrescriber: null,
      selectedUser: null,
      saveSuccess: null
    }
  }

  componentDidMount () {
    const { getUsers } = this.props
    getUsers(constants.SALES_ROLE)
  }

  updateSalesPerson = (e) => {
    const { updateSalesPerson } = this.props
    const { selectedPrescriber, selectedUser } = this.state
    if (!selectedPrescriber) {
      alert('Missing Prescriber')
    } else if (!selectedUser) {
      alert('Missing User')
    }
    updateSalesPerson(selectedPrescriber.id, selectedUser.user_id)
    .then(() => {
      this.setState({
        saveSuccess: true
      })
    })
    .catch((err) => {
      console.error(err)
      this.setState({
        saveSuccess: false
      })
    })
    e.preventDefault()
  }

  handleSelectPrescriber = (prescriber) => {
    const { users } = this.props
    const { selectedUser } = this.state
    let newSelectedUser = null
    if (prescriber.sales_person_id) {
      newSelectedUser = _.find(users, (u) => u.user_id === prescriber.sales_person_id)
    }
    this.setState({
      selectedPrescriber: prescriber,
      selectedUser: selectedUser || newSelectedUser
    })
  }

  handleSelectUser = (user) => {
    this.setState({
      selectedUser: user
    })
  }

  render () {
    const { isFetchingUsers, users, isFetchingPrescribers, prescribers } = this.props
    const { selectedUser, selectedPrescriber, saveSuccess } = this.state

    const labeledPrescribers = _.map(prescribers, (p) => {
      return {
        ...p,
        name: `${p.first_name} ${p.last_name}`
      }
    })

    return (
      <div>
        <div style={{ paddingTop: 20 }}>
          <h4>Select Prescriber</h4>
          <Select
            isSearchable
            isClearable
            isLoading={isFetchingPrescribers}
            options={labeledPrescribers}
            value={selectedPrescriber}
            onChange={(selected) => this.handleSelectPrescriber(selected)}
            onBlurResetsInput={false}
            onCloseResetsInput={false}
            noResultsText={false}
            labelKey={'name'}
            valueKey={'id'}
          />
        </div>
        <div style={{ paddingTop: 20 }}>
          <h4>Select User</h4>
          <Select
            isSearchable
            isClearable
            isLoading={isFetchingUsers}
            options={users}
            value={selectedUser}
            onChange={(selected) => this.handleSelectUser(selected)}
            onBlurResetsInput={false}
            onCloseResetsInput={false}
            noResultsText={false}
            labelKey={'email'}
            valueKey={'user_id'}
          />
        </div>
        <div style={{ marginTop: 20 }}>
          <button className='btn btn-primary' onClick={this.updateSalesPerson}>Save</button>
        </div>
        <div style={{ marginTop: 20 }}>
          {
            saveSuccess ? (
              <div className='alert alert-success' role='alert'>Success</div>
            ) : null
          }
        </div>
      </div>
    )
  }
}

export default SalesAssignment



// WEBPACK FOOTER //
// ./src/routes/Clinic/components/SalesAssignment.jsx